import React from 'react';

import {
    ReactBaseComponent,
    SC,
    Utils,
    AppState,
    Links,
    Events,
    AppLayout,
    Globals
} from '../../../importer';

// import admin from "firebase-admin";

import {SignUpButton, SubmitButton, SignIn_SocialMedia, Terms_Link, LoginBox, AuthErrorBox} from '../../../views/auth';
import Logo from '../../../views/logo/brand_logo';
import FormInput from '../../../views/auth/FormInput';

// const TOOLABS_URL = "http://localhost:5000/#/";
const TOOLABS_URL = "http://app.toolabs.com/#/";

export default class FigmaSignin extends React.Component {
    constructor(props) {
        super(props);
        this.state = {  
            // waitingResponse : true
        }

        this.Submit = this.Submit.bind(this);
        this.SignInGoogle = this.SignInGoogle.bind(this);
        this.SignInTwitter = this.SignInTwitter.bind(this);
        this.ResetPassword = this.ResetPassword.bind(this);

        this.ErrorMessage = "";
    }
    ResetPassword() {
        var isValid = this.Ref_Email.validate();
        if (isValid) {
            this.setState({processing : true});
            AppState.ResetPassword(this.Ref_Email.getValue())
            .then(
                (result) => {
                    if (result.error) {
                        this.ErrorMessage = result.errorMessage;
                        this.setState({processing : false});
                    }
                    else {
                        alert("Password Reset Email Sent! Check your Inbox.");
                        this.setState({processing : false});
                    }
                }
            );
        }
    }
    Submit() {        
        if (this.props.isAuthenticated) {
            this.props.onAuthenticated();
        }
        if (this.state.signUp) {
            var isValid = this.Ref_Password.validate() & this.Ref_Email.validate() & this.Ref_UserName.validate();

            if (isValid) {
                AppState.SignUp({
                    email : this.Ref_Email.getValue(), 
                    password : this.Ref_Password.getValue(), 
                    user : this.Ref_UserName.getValue(),
                    reguestId : this.requestId, 
                    appSource : 'figma', 
                    callback : ({userid, error})=>{
                        if (error) {
                            this.ErrorMessage = error.message;
                            this.setState({processing : false});
                        }
                        else if (userid)
                            this.LoginSuccessful({uid: userid});
                    }
                });               
            }
        }
        else {
            var isValid = this.Ref_Password.validate() & this.Ref_Email.validate();
            if (isValid) {
                this.setState({
                    processing : true
                });
                AppState.Login(this.Ref_Email.getValue(), this.Ref_Password.getValue(),
                    (result) => {                        
                        if (result && result.Error) {                            
                            this.ErrorMessage = result.Message;                            
                            this.setState({
                                processing : false
                            });
                        } else {
                            this.setState({
                                processing : false
                            });
                            this.LoginSuccessful(result.User.user);
                        }
                    });
            }
        }
    }
    LoginSuccessful(user) {
        this.props.onAuthenticated();
    }
    SignInGoogle() {
        
        this.requestId = Utils.Id();

        window.open( `${TOOLABS_URL}authFigma?requestId=${this.requestId}`, "_blank"); 

        this.setState({
            waitingResponse : true
        });

        AppState.GetDataApi().isFigma = true;
        const firebaseapi = AppState.GetDataApi().api;
        

        var path = "/api/figma/authRequests/" + this.requestId + "/";
        var commentsRef = firebaseapi.getFirebase().database().ref(path);
        const listener = commentsRef.on("child_added", (dataSnapshot, key) => {            
            const value = dataSnapshot.val();
            
            if (value) {
                if (listener)
                    commentsRef.off('child_added', listener);
                commentsRef.remove();

                fetch("https://xdapi.toolabs.com/getAuthToken", {
                    body: JSON.stringify({"uid" : value}),
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json"
                    },
                    method: "POST"
                }).then((response) => {
                    if (response) {
                        response.json().then((data) => {                            
                            if (data && data.token) {
                                const firebaseapi2 = AppState.GetDataApi().api;
                                firebaseapi2.getFirebase().auth().signInWithCustomToken(data.token);
                                this.LoginSuccessful({uid: value});                        
                            }
                        })                
                    }
                })
            }
        });
    }
    SignInTwitter() {
        this.setState({processing : true});
        AppState.LoginWithTwitter({notPopup : true, appSource : this.props.appSource}).then(
            (userid) => {
                this.ErrorMessage = "";
                this.setState({signUp : false, processing : false})
            },
            (error) => {
                this.ErrorMessage = error.message;
                this.setState({processing : false});
            }
        );
    }
    render() { 
        let content;

        if (this.state.waitingResponse) {
            content = (
                <SC.FCol alc style={{
                    boxShadow : SC.CurrentTheme.theme.popup_shadow,
                    borderRadius : '4px',
                    padding : '24px'
                }}>            
                    <SC.FCol alc style={{fontSize : '12px', marginBottom : '16px', lineHeight : '22px', textAlign : 'center'}}>
                        <div>Toolabs authentication form is opened in your browser.</div>
                        <SC.Div_Flex_Cell style={{margin : '16px'}}>
                            <SC.Loading_Icon />
                        </SC.Div_Flex_Cell>
                        <div>Please sign in to Toolabs and then return back to Figma.</div>
                    </SC.FCol>     
                    
                    <SC.Buttons.RoundButton style={{marginTop : '16px'}} small onClick={() => {this.setState({waitingResponse : false});}}>Cancel</SC.Buttons.RoundButton>
                </SC.FCol>
            )
        }
        else {
            if (this.state.signUp) {
                content = (
                    <SC.FCol alignStretch>
                        <SC.FRow justifyEnd alc mb={16}>
                                Already have an account?
                                <SignUpButton onClick={() => this.setState({signUp : false})}>LOGIN</SignUpButton>
                            </SC.FRow>
                            <FormInput
                                ref={(r) => this.Ref_UserName = r}
                                label="Name"
                                type='name'
                                value={this.UserName}
                                onSubmit={this.Submit}
                            />
                            <FormInput
                                key='email'
                                ref={(r) => this.Ref_Email = r}
                                type='email'
                                label="Email"
                                value={this.Email}
                                onSubmit={this.Submit}
                            />
                            <FormInput
                                key='password'
                                ref={(r) => this.Ref_Password = r}
                                label="Password"
                                type='password'
                                value={this.Password}
                                onSubmit={this.Submit}
                            />
                            <SC.FCol alignStretch mt={20} mb={10}>
                                <SubmitButton onClick={this.Submit} >SIGN UP</SubmitButton>
                                {this.ErrorMessage.length > 0 && <AuthErrorBox isInvalid={this.ErrorMessage && this.ErrorMessage.length > 0 ? true : false}>
                                    {this.ErrorMessage}
                                </AuthErrorBox>
                                }
                            </SC.FCol>
                            <SignIn_SocialMedia signUp SignInGoogle={this.SignInGoogle} SignInTwitter={this.SignInGoogle} />
                            <Terms_Link >
                                By signing up you agree to our <a href="#" onClick={this.showTerms}>  Terms & Conditions </a> and <a href="#" onClick={this.showPrivacyPolicy}>  Privacy Policy </a>
                            </Terms_Link>
                    </SC.FCol>
                )
            }
            else {
                content = (
                    <SC.FCol alignStretch>
                        <SC.FRow justifyEnd alc mb={16}>
                            Don't have an account?
                            <SignUpButton onClick={() => this.setState({signUp : true})}>Get One</SignUpButton>
                        </SC.FRow>
                        <FormInput
                            key='email'
                            ref={(r) => this.Ref_Email = r}
                            autoFocus
                            label="Email"
                            type='email'
                            value={this.Email}
                            onSubmit={this.Submit}
                        />
                        <FormInput
                            key='password'
                            ref={(r) => this.Ref_Password = r}
                            label="Password"
                            type='password'
                            value={this.Password}
                            onSubmit={this.Submit}
                            style={{marginBottom : '4px'}}
                        />
                        <SC.LinkText style={{alignSelf : 'flex-end'}} onClick={() => this.ResetPassword()}>Forgot your password?</SC.LinkText>
                        <SC.FCol alignStretch mt={20} mb={10}>
                            <SubmitButton onClick={this.Submit} >LOGIN</SubmitButton>
                            {this.ErrorMessage.length > 0 && <AuthErrorBox isInvalid={this.ErrorMessage && this.ErrorMessage.length > 0 ? true : false}>
                                {JSON.stringify(this.ErrorMessage)}
                            </AuthErrorBox>
                            }
                        </SC.FCol>                    
                        <SignIn_SocialMedia SignInGoogle={this.SignInGoogle} SignInTwitter={this.SignInGoogle} />
                    </SC.FCol>
                )
            }
        }
        
        return (  
            <SC.FCol f1 alignStretch style={{ maxWidth: '440px', zIndex: 10, padding: '16px' }} jsb >
                <SC.FCol f1>
                    <SC.Div_Flex_Cell style={{paddingTop : '16px', paddingBottom : '16px'}}>
                        <Logo isLight={SC.CurrentTheme.theme.isLight} size={140} />
                    </SC.Div_Flex_Cell>
                    <SC.Div_Flex_Cell style={{color : SC.CurrentTheme.theme.isLight ? '#4C5765' : 'unset', fontSize : '18px', lineHeight : '1.5em', textAlign : 'center'}}>
                        Design System Manager
                    </SC.Div_Flex_Cell>
                    <SC.FCol style={{ marginTop: '36px', alignItems : 'stretch' }}>
                        {content}
                    </SC.FCol>    
                </SC.FCol>
                <SC.FCol justifyEnd>
                    <div style={{
                        display : 'grid',
                        gridGap : '16px',
                        gridTemplateColumns : 'auto auto auto',
                        alignItems : 'center',
                        justifyItems : 'end',
                        marginBottom : '8px',
                        justifyContent : 'center'
                    }}>
                        <a style={{gridColumnStart : 'span 3', fontSize : '14px', justifySelf : 'start'}} href='https://www.toolabs.com/' target='_blank'>www.toolabs.com</a>
                        <a href="https://www.linkedin.com/company/25008330/" target="_blank"><img style={{width : '32px'}} src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjBweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMjAgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ3LjEgKDQ1NDIyKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5saW5rZWRpbl9pY29uPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlN5bWJvbHMiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJsaW5rZWRpbl9pY29uIiBmaWxsPSIjN0E4Njk0IiBmaWxsLXJ1bGU9Im5vbnplcm8iPgogICAgICAgICAgICA8cGF0aCBkPSJNOS44NjMwMSwwIEM0LjQzODM2LDAgMCw0LjM5MDI1IDAsOS43NTYxIEMwLDE1LjEyMiA0LjQzODM2LDE5LjUxMjIgOS44NjMwMSwxOS41MTIyIEMxNS4yODc3LDE5LjUxMjIgMTkuNzI2LDE1LjEyMiAxOS43MjYsOS43NTYxIEMxOS44MjQ3LDQuMzkwMjUgMTUuMzg2MywwIDkuODYzMDEsMCBaIE03LjM5NzI2LDEzLjY1ODUgTDUuMDMwMTQsMTMuNjU4NSBMNS4wMzAxNCw3LjgwNDg4IEw3LjI5ODYzLDcuODA0ODggTDcuMjk4NjMsMTMuNjU4NSBMNy4zOTcyNiwxMy42NTg1IFogTTYuMjEzNyw2LjgyOTI3IEM1LjUyMzI5LDYuODI5MjcgNS4wMzAxNCw2LjM0MTQ3IDUuMDMwMTQsNS43NTYxIEM1LjAzMDE0LDUuMTcwNzMgNS41MjMyOSw0LjY4MjkzIDYuMjEzNyw0LjY4MjkzIEM2LjkwNDExLDQuNjgyOTMgNy4zOTcyNiw1LjE3MDczIDcuMzk3MjYsNS43NTYxIEM3LjM5NzI2LDYuMzQxNDcgNi45MDQxMSw2LjgyOTI3IDYuMjEzNyw2LjgyOTI3IFogTTE0LjY5NTksMTMuNjU4NSBMMTIuNDI3NCwxMy42NTg1IEwxMi40Mjc0LDEwLjQzOSBDMTIuNDI3NCw5Ljk1MTIyIDEyLjAzMjksOS41NjA5OCAxMS41Mzk3LDkuNTYwOTggQzExLjA0NjYsOS41NjA5OCAxMC42NTIxLDkuOTUxMjIgMTAuNjUyMSwxMC40MzkgTDEwLjY1MjEsMTMuNjU4NSBMOC4yODQ5MywxMy42NTg1IEM4LjI4NDkzLDEzLjY1ODUgOC4yODQ5Myw4LjE5NTEzIDguMjg0OTMsNy43MDczMiBMMTAuNTUzNCw3LjcwNzMyIEwxMC41NTM0LDguMzkwMjUgQzEwLjU1MzQsOC4zOTAyNSAxMS4yNDM4LDcuNzA3MzIgMTIuMzI4OCw3LjcwNzMyIEMxMy43MDk2LDcuNzA3MzIgMTQuNjk1OSw4LjY4MjkzIDE0LjY5NTksMTAuNTM2NiBMMTQuNjk1OSwxMy42NTg1IFoiPjwvcGF0aD4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPg==" alt="" /></a>
                        <a href="https://twitter.com/ToolabsLive" target="_blank"><img style={{width : '32px'}} src="data:image/svg+xml;base64,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" alt="" /></a>
                        <a href="https://www.facebook.com/ToolabsLive" target="_blank"><img style={{width : '32px'}} src="data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB3aWR0aD0iMjBweCIgaGVpZ2h0PSIyMHB4IiB2aWV3Qm94PSIwIDAgMjAgMjAiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8IS0tIEdlbmVyYXRvcjogU2tldGNoIDQ3LjEgKDQ1NDIyKSAtIGh0dHA6Ly93d3cuYm9oZW1pYW5jb2RpbmcuY29tL3NrZXRjaCAtLT4KICAgIDx0aXRsZT5mYWNlYm9va19pY29uPC90aXRsZT4KICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPgogICAgPGRlZnM+PC9kZWZzPgogICAgPGcgaWQ9IlN5bWJvbHMiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgICAgIDxnIGlkPSJmYWNlYm9va19pY29uIiBmaWxsPSIjN0E4Njk0IiBmaWxsLXJ1bGU9Im5vbnplcm8iPgogICAgICAgICAgICA8cGF0aCBkPSJNMTAuMDAwMDA5OSwxLjE2MzAyZS0wOCBDNC40OTk5OTk3LDEuMTYzMDJlLTA4IC0zLjQxMDYwNTEzZS0xMyw0LjUwMDAwNTEzIC0zLjQxMDYwNTEzZS0xMywxMCBDLTMuNDEwNjA1MTNlLTEzLDE1LjUwMDA0NjEgNC40OTk5OTk3LDIwIDEwLjAwMDAwOTksMjAgQzE1LjUwMDA1MDYsMjAgMjAsMTUuNTAwMDQ2MSAyMCwxMCBDMjAsNC41MDAwMDUxMyAxNS41MDAwNTA2LDEuMTYzMDJlLTA4IDEwLjAwMDAwOTksMS4xNjMwMmUtMDggWiBNMTIuOTk5OTk5OSw5LjYwMDAwNDExIEwxMS4zMDAwMSw5LjYwMDAwNDExIEwxMS4zMDAwMSwxNS40MDAwMDYyIEw4LjgwMDAwOTkzLDE1LjQwMDAwNjIgTDguODAwMDA5OTMsOS42MDAwMDQxMSBMNy4xMDAwMDk4OSw5LjYwMDAwNDExIEw3LjEwMDAwOTg5LDcuOTAwMDAxMDMgTDguODAwMDA5OTMsNy45MDAwMDEwMyBMOC44MDAwMDk5Myw2LjkwMDAwMTAzIEM4LjgwMDAwOTkzLDYgOS4xMDAwMDk5Myw0LjYwMDAwNDEgMTAuOTk5OTk5OCw0LjYwMDAwNDEgTDEyLjk5OTk5OTksNC42MDAwMDQxIEwxMi45OTk5OTk5LDYuNTAwMDA1MTMgTDExLjgwMDA2MDcsNi41MDAwMDUxMyBDMTEuNjAwMDIwMSw2LjUwMDAwNTEzIDExLjMwMDAxLDYuNjAwMDA0MSAxMS4zMDAwMSw3IEwxMS4zMDAwMSw3LjkwMDAwMTAzIEwxMy4yMDAwNDA0LDcuOTAwMDAxMDMgTDEyLjk5OTk5OTksOS42MDAwMDQxMSBaIj48L3BhdGg+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4=" alt="" /></a>
                    </div>
                    <SC.TextDivAbbr style={{fontSize : '11px', textAlign : 'center'}}>Copyright © 2020 Toolabs Company. All Rights Reserved.</SC.TextDivAbbr>
                </SC.FCol>
            </SC.FCol>            
        );
    }
}
